import { useMembersContext } from '@/contexts/membersContext';
import { LeadSource } from '@/types/leadSource';
import ajax from '@/utils/ajax';

export const leadSourceRepository = {
  BASE_PATH: '/api/lead_sources/',

  async list(host: string): Promise<LeadSource[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`
    });

    return response.data;
  }
};

export const LeadSourceRepository = () => {
  const { host } = useMembersContext();

  return {
    async list() {
      return leadSourceRepository.list(host);
    }
  };
};
